import React from 'react';
import { Paper, Typography, Divider, Grid } from '@mui/material';

const ViewTestCategory = ({ category }) => {
  if (!category) {
    return null;
  }

  return (
    <Paper elevation={3} sx={{ padding: 3, marginTop: 3 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Category Overview
      </Typography>
      <Divider sx={{ mb: 2 }} />

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2">
            Test Category: {category.testCategory}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2">
            GL Code: {category.glCode}
          </Typography>
        </Grid>
        {/* Add more details as needed */}
      </Grid>
    </Paper>
  );
};

export default ViewTestCategory;
